export default "__VITE_PUBLIC_ASSET__f102c71c__"